import claudiaAPI from 'dashboard/api/claudiaAPI';
import {
  conversationUIFlagsGetter,
  conversationRecordStatusGetter,
  conversationStatusMutations,
  fetchConversationResource,
} from './helpers/claudiaConversationStore';

const state = {
  records: {},
  uiFlags: {},
  recordStatus: {},
};

const getters = {
  getConversationEvents: _state => conversationUuid => {
    const events = _state.records[conversationUuid] || [];
    return events.filter(e => !e.messageId);
  },
  getMessageEvents: _state => conversationUuid => {
    const events = _state.records[conversationUuid] || [];
    return events.filter(e => !!e.messageId);
  },
  getUIFlags: conversationUIFlagsGetter,
  getRecordStatus: conversationRecordStatusGetter,
};

const mutations = {
  SET_CLAUDIA_EVENTS(currentState, { conversationUuid, events }) {
    currentState.records = {
      ...currentState.records,
      [conversationUuid]: events,
    };
  },
  ...conversationStatusMutations,
};

const actions = {
  async fetch(context, { conversationUuid }) {
    await fetchConversationResource(
      context,
      { conversationUuid },
      {
        request: (uuid, store) => claudiaAPI.getConversationEvents(uuid, store),
        onSuccess: (commit, uuid, events) =>
          commit('SET_CLAUDIA_EVENTS', { conversationUuid: uuid, events }),
      }
    );
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
